import {v1 as getUUID} from 'uuid';
import sdk from '@/sdk';
import * as store from '@/store';
import toast, {ToastType} from '@/components/Toast';
import {feLogger, PDFClickConvertWord} from '@/buried';

const ErrorCodeMap = {
    convertError: 40125, // pdf转word失败
    repeatTaskId: 40126, // taskId重复
    userAbsent: 10312, // 该用户在知识库不存在
    NoPermissionAccount: 40130, // 该用户无对应的如流账号
};

export const usePdf2Word = (docGuid: string, userGuid: string) => {
    // 存储正在转换中的文档
    const isConvertingMap: {
        [id: string]: boolean;
    } = {};

    // 转换 发起转换+该用户无对应的如流账号+接口异常 可以快速得到结果在知识库toast提示 其他转换失败如流通知
    async function convertPDF2Word(id: string, fileId: string) {
        feLogger(PDFClickConvertWord({
            page_id: docGuid,
        }));
        const ksServer = await sdk.getKsServer();
        const taskId = getUUID();
        isConvertingMap[id] = true;
        return new Promise((resolve, reject) => {
            ksServer.pdfConvertWord(docGuid, fileId, taskId, userGuid)
                .then((result) => {
                    if (isConvertingMap[id]) {
                        isConvertingMap[id] = false;
                        toast({
                            duration: 3000,
                            type: ToastType.Success,
                            content: 'PDF文件转换中，转换成功后将在【知识通知】发送转换后的Word文件',
                        });
                        resolve({type: 'success', ...result});
                    } else {
                        reject({type: 'fail', taskId});
                    }
                })
                .catch((err) => {
                    if (err.toResult().returnCode === ErrorCodeMap.convertError) {
                        if (isConvertingMap[id]) {
                            isConvertingMap[id] = false;
                        }
                        toast({
                            type: ToastType.Error,
                            content: '服务异常',
                        });
                        reject({type: 'fail', taskId});
                    } else if (err.toResult().returnCode === ErrorCodeMap.repeatTaskId) {
                        if (isConvertingMap[id]) {
                            isConvertingMap[id] = false;
                            convertPDF2Word(id, fileId);
                        }
                        toast({
                            type: ToastType.Error,
                            content: '转换失败',
                        });
                    } else if (err.toResult().returnCode === ErrorCodeMap.NoPermissionAccount) {
                        if (isConvertingMap[id]) {
                            isConvertingMap[id] = false;
                            toast({
                                type: ToastType.Error,
                                content: '当前账号未绑定如流，无法转换',
                            });
                        }
                        reject({type: 'fail', taskId});
                    } else { // 非超时场景resolve fail
                        if (isConvertingMap[id]) {
                            isConvertingMap[id] = false;
                        }
                        toast({
                            type: ToastType.Error,
                            content: '转换失败',
                        });
                        reject({type: 'fail', taskId});
                    }
                });
        });
    }

    return {convertPDF2Word};
};
